import { useEffect } from 'react'

import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { usePageTitle } from 'context/pageTitleContext'
import DesktopAdditionalContent from 'features/DesktopAdditionalContent/DesktopAdditionalContent'

import { CreateTicket, Home, TicketsList } from './pages'

export const Support = () => {
    const { t } = useTranslation()
    const { id } = useParams<any>()
    const { setTitle } = usePageTitle()

    const renderPages = () => {
        switch (id) {
            case 'home':
                return <Home />
            case 'submit-ticket':
                return <TicketsList />
            default:
                return <CreateTicket />
        }
    }

    useEffect(() => {
        setTitle(t('support'))
    }, [setTitle])

    return (
        <div className='support-container'>
            {renderPages()}
            <DesktopAdditionalContent />
        </div>
    )
}
